import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const SizesTable = ({ data, onEdit, onDelete }) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Display Name</TableCell>
            <TableCell>Internal Name</TableCell>
            <TableCell>Price</TableCell>
            <TableCell>Servings</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((size) => (
            <TableRow key={size._id}>
              <TableCell>{size.displayName}</TableCell>
              <TableCell>{size.name}</TableCell>
              <TableCell>${size.price}</TableCell>
              <TableCell>{size.servings}</TableCell>
              <TableCell align="right">
                <IconButton color="primary" onClick={() => onEdit(size)}>
                  <EditIcon />
                </IconButton>
                <IconButton
                  color="secondary"
                  onClick={() => onDelete(size._id)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SizesTable;
